
import * as constants from "@/core/config/constant";
import * as InputMethods from "./InputMethods";


export const CHECK_METHOD_REQUIRED = 1
export const CHECK_METHOD_DUPLICATE = 2
export const CHECK_METHOD_NUMBER = 3
export const CHECK_METHOD_HALFWIDTH_CHARACTERS = 4
export const CHECK_METHOD_KANA_ONLY = 5
export const CHECK_METHOD_URL = 6
export const CHECK_METHOD_EMAIL = 7
export const CHECK_METHOD_NUMBER_DIGITS = 8
export const CHECK_METHOD_CAPACTITY = 9
export const CHECK_METHOD_EXTENSTION = 10
export const CHECK_METHOD_HIRAGANA_ONLY = 11
export const CHECK_METHOD_HALFWIDTH_ONLY = 12
export const CHECK_METHOD_PHONE_NUMBER = 13

export const getCheckMethodOptions = (input_method) => {
    let options;
    switch (input_method) {
        case InputMethods.INPUT_METHOD_TEXT_SINGLE: {
            options = filterCheckMethod(constants.CHECK_METHOD_INPUT_TEXT)
            break;
        } case InputMethods.INPUT_METHOD_TEXT_MULTI: {
            options = filterCheckMethod(constants.CHECK_METHOD_TEXT_MULTI)
            break;
        }
        case InputMethods.INPUT_METHOD_SELECTION_SINGLE:
        case InputMethods.INPUT_METHOD_SELECTION_MULTI: {
            options = filterCheckMethod(constants.CHECK_METHOD_INPUT_CHECKBOK_)
            break;
        }

        case InputMethods.INPUT_METHOD_FILE: {
            options = filterCheckMethod(constants.CHECK_METHOD_INPUT_FILE)
            break;
        }
        case InputMethods.INPUT_METHOD_LABEL:
        case InputMethods.INPUT_METHOD_ATTACHMENT:
        case InputMethods.INPUT_METHOD_CALCULATION: {
            options = []
            break;
        }
        case InputMethods.INPUT_METHOD_DATE: {
            options = filterCheckMethod(constants.CHECK_METHOD_INPUT_CHECKBOK_)
            break;
        }

        default: {
            options = filterCheckMethod(constants.CHECK_METHOD_DEFAULT_ALL)
        }
    }
    return [ {
        label: 'なし',
        value: ' '
    },...options]
}

export const filterCheckMethod = (listObj) => {
    return constants.CHECK_METHOD.filter((el) => {
        return listObj.includes(el.value)
    })
}

export const isShowSizeRange = (input) => {
    return input.check_method.indexOf(CHECK_METHOD_CAPACTITY) > -1
}

export const isShowDigitRange = (input) => {
    return input.check_method.indexOf(CHECK_METHOD_NUMBER_DIGITS) > -1
}

export const isShowAcceptableExtensions= (input) => {
    return input.check_method.indexOf(CHECK_METHOD_EXTENSTION) > -1
}